import { useQuery } from '@tanstack/react-query';

import { fetchBusinessPartnerDetail, fetchBusinessPartners } from './api';
import { businessPartnerComboboxQueryKey } from './key';
import { mapBusinessPartnersToOptions } from './selector';
import type { BusinessPartnerItem } from './type';

export const useBusinessPartners = (searchText: string) =>
  useQuery({
    queryKey: businessPartnerComboboxQueryKey.list(searchText),
    queryFn: () => fetchBusinessPartners(searchText),
    select: (data: BusinessPartnerItem[]) => mapBusinessPartnersToOptions(data),
    initialData: [],
  });

export const useBusinessPartnerDetail = (businessPartnerId: string | null) =>
  useQuery({
    queryKey: businessPartnerComboboxQueryKey.detail(businessPartnerId ?? ''),
    queryFn: () => fetchBusinessPartnerDetail(businessPartnerId ?? ''),
    enabled: Boolean(businessPartnerId),
  });
